import React, { useEffect, createElement } from 'react';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { ProductShowcase } from './components/ProductShowcase';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { ProBusiness } from './components/ProBusiness';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { DarkCTA } from './components/DarkCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const HERO_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_400/v1777315254/hf_20260427_035025_41cb6e8f-bd9f-4f1e-93c1-5391b40dad44-Photoroom_ahu5x8.webp';
const OG_IMG = 'https://cdn.magicpatterns.com/uploads/9uMhQHg3RXXbKPqANDF9n5/hf_20260423_164447_343907b5-95aa-49ff-ba71-eeea9d0be6f6-Photoroom.webp';
export function App() {
  useEffect(() => {
    const runSeo = () => {
      document.title = 'Megapack Estimulación Temprana para Madres — Los 1000 Días que Cambian Todo';
      document.documentElement.lang = 'es';
      const setMeta = (name: string, content: string, property?: boolean) => {
        const attr = property ? 'property' : 'name';
        let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement;
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute(attr, name);
          document.head.appendChild(el);
        }
        el.content = content;
      };
      const description = 'El sistema completo de estimulación temprana para madres argentinas. 6 Tomos de 60 páginas cada uno, con actividades mes a mes para el desarrollo motor, del lenguaje, cognitivo, emocional y neurológico de tu hijo de 0 a 36 meses. Más 6 bonos exclusivos. Acceso inmediato.';
      const url = 'https://estimulaciontemprana.com';
      const image = OG_IMG;
      setMeta('description', description);
      setMeta('keywords', 'estimulación temprana, megapack estimulación, desarrollo neurológico bebés, estimulación 0 a 3 años, madres Argentina, neurodesarrollo infantil, actividades bebés, desarrollo motor bebé, lenguaje bebés, estimulación temprana Argentina');
      setMeta('robots', 'index, follow');
      setMeta('author', 'Megapack Estimulación Temprana');
      setMeta('viewport', 'width=device-width, initial-scale=1');
      if (!document.querySelector('link[rel="canonical"]')) {
        const canonical = document.createElement('link');
        canonical.rel = 'canonical';
        canonical.href = url;
        document.head.appendChild(canonical);
      }
      setMeta('og:title', 'Megapack Estimulación Temprana para Madres — Los 1000 Días que Cambian Todo', true);
      setMeta('og:description', description, true);
      setMeta('og:image', image, true);
      setMeta('og:url', url, true);
      setMeta('og:type', 'product', true);
      setMeta('og:locale', 'es_AR', true);
      setMeta('og:site_name', 'Megapack Estimulación Temprana™', true);
      setMeta('twitter:card', 'summary_large_image');
      setMeta('twitter:title', 'Megapack Estimulación Temprana para Madres — Los 1000 Días que Cambian Todo');
      setMeta('twitter:description', description);
      setMeta('twitter:image', image);
      if (!document.querySelector('script[data-ld="product"]')) {
        const ld = document.createElement('script');
        ld.type = 'application/ld+json';
        ld.setAttribute('data-ld', 'product');
        ld.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Product',
          name: 'Megapack Estimulación Temprana para Madres — Sistema Completo™',
          description,
          image,
          brand: {
            '@type': 'Brand',
            name: 'Megapack Estimulación Temprana™'
          },
          offers: {
            '@type': 'AggregateOffer',
            lowPrice: '19990',
            highPrice: '27990',
            priceCurrency: 'ARS',
            availability: 'https://schema.org/InStock',
            offerCount: 2
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '634'
          }
        });
        document.head.appendChild(ld);
      }
      if (!document.querySelector('script[data-ld="org"]')) {
        const orgLd = document.createElement('script');
        orgLd.type = 'application/ld+json';
        orgLd.setAttribute('data-ld', 'org');
        orgLd.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Megapack Estimulación Temprana™',
          url,
          logo: image,
          email: 'hola@estimulaciontemprana.com',
          sameAs: ['https://www.instagram.com/estimulaciontemprana']
        });
        document.head.appendChild(orgLd);
      }
      if (!document.querySelector('script[data-ld="faq"]')) {
        const faqLd = document.createElement('script');
        faqLd.type = 'application/ld+json';
        faqLd.setAttribute('data-ld', 'faq');
        faqLd.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [{
            '@type': 'Question',
            name: '¿Qué incluye el Megapack Estimulación Temprana?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '6 Tomos completos de 60 páginas cada uno, con actividades mes a mes organizadas por área de desarrollo motor, lenguaje, cognitivo, emocional y neurológico. Semáforos de alerta, protocolos de estimulación y checklists de hitos. Más 6 bonos exclusivos.'
            }
          }, {
            '@type': 'Question',
            name: '¿Cómo recibo el material?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Todo es 100% digital en formato PDF. Recibís acceso inmediato en tu email dentro de los 5 minutos posteriores a la compra.'
            }
          }, {
            '@type': 'Question',
            name: '¿Tiene garantía?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Sí, ofrecemos garantía de 7 días sin preguntas. Si no te sirve, te devolvemos el 100% de tu dinero.'
            }
          }, {
            '@type': 'Question',
            name: '¿Está adaptado a Argentina?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Sí, 100%. Los protocolos, actividades y recomendaciones están adaptados al contexto cultural, social y sanitario argentino.'
            }
          }, {
            '@type': 'Question',
            name: '¿Para qué edad de niño está pensado este sistema?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Para niños de 0 a 36 meses. Cada tomo cubre un período de 6 meses con actividades específicas para el desarrollo motor, del lenguaje, cognitivo, emocional y neurológico.'
            }
          }]
        });
        document.head.appendChild(faqLd);
      }
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(runSeo, {
        timeout: 1500
      });
    } else {
      setTimeout(runSeo, 100);
    }
  }, []);
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      (window as any).fbq('init', '1215304437119773');
      (window as any).fbq('track', 'PageView');
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
  }, []);
  return <>
      <noscript data-id="element-0">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1215304437119773&ev=PageView&noscript=1" alt="" data-id="element-1" />
      </noscript>

      <header className="relative flex w-full flex-col items-center justify-center text-center text-gray-900 text-base leading-6 px-5 sm:px-6 py-12 sm:py-16" role="banner" style={{
      backgroundImage: 'linear-gradient(135deg, rgb(253,244,255) 0%, rgb(243,232,255) 30%, rgb(253,244,255) 60%, rgb(252,248,255) 100%)',
      backgroundColor: 'rgb(253,244,255)'
    }} data-id="element-2">
        {/* ── 1. BADGE ── */}
        <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-purple-400/30 bg-white/80 px-4 py-1.5 shadow-sm" data-id="element-3">
          <span className="text-xs sm:text-sm font-bold text-purple-700 tracking-wide uppercase" data-id="element-4">
            🧠 Sistema de Estimulación Temprana · Madres Argentina
          </span>
        </div>

        {/* ── 2. H1 ── */}
        <h1 className="sm:text-5xl md:text-[72px] sm:leading-snug md:leading-[88px] font-black max-w-4xl text-gray-900 m-0 mb-2 text-[28px] leading-10 tracking-tight" data-id="element-5">
          Los primeros 3 años
          <br data-id="element-6" />
          son para siempre.
          <br data-id="element-7" />
          <span className="text-purple-600 mt-1 inline-block" data-id="element-8">
            No los improvises.
          </span>
        </h1>

        {/* ── 3. MOCKUP (LCP element) ── */}
        <div className="my-6 sm:my-8 w-full max-w-[320px] sm:max-w-[380px] aspect-square relative" data-id="element-9">
          <div className="absolute inset-4 rounded-full z-0 pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(168,85,247,0.30) 0%, rgba(236,72,153,0.10) 50%, transparent 70%)'
        }} data-id="element-10" />
          <div className="relative z-10 w-full h-full" data-id="element-11">
            <img src={HERO_IMG} alt="Megapack Estimulación Temprana para Madres — Sistema Completo de Neurodesarrollo 0 a 36 Meses" width="400" height="400" fetchPriority="high" decoding="sync" className="block max-w-full w-full h-auto object-contain drop-shadow-2xl" data-id="element-12" />
          </div>
        </div>

        {/* ── 4. SUBTÍTULO ── */}
        <p className="max-w-xl text-base sm:text-lg font-semibold text-gray-700 leading-7 m-0 mb-4" data-id="element-13">
          El sistema que las madres más preparadas usan para acompañar el
          desarrollo motor, del lenguaje, cognitivo, emocional y neurológico de
          sus hijos con confianza, con herramientas reales y{' '}
          <span className="text-gray-900 font-black" data-id="element-14">
            sin perder el tiempo que no tienen.
          </span>
        </p>

        {/* ── 5. TAGLINE MECANISMO ── */}
        <p className="max-w-xl text-lg sm:text-xl font-black text-purple-600 m-0 mb-6" data-id="element-15">
          "360 páginas de estimulación integral.
          <br className="hidden sm:block" data-id="element-16" />
          Sin improvisar más, sin agotarte más."
        </p>

        {/* ── 6. TAGS ── */}
        <div className="mb-7 flex max-w-lg flex-wrap items-center justify-center gap-2" data-id="element-17">
          {['📄 100% PDF', '⚡ Acceso Inmediato', '🇦🇷 Argentina', '🧠 Neurodesarrollo', '✅ Sistema Listo', '👶 6 Tomos + 6 Bonos'].map(tag => <span key={tag} className="whitespace-nowrap bg-white/80 text-xs sm:text-sm font-semibold text-gray-900 leading-5 border border-purple-400/30 rounded-full px-3 py-1 shadow-sm" data-id="element-18">
              {tag}
            </span>)}
        </div>

        {/* ── 7. CTA BUTTON ── */}
        <a href="#pricing" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'Lead', {
            content_name: 'Hero CTA Click',
            content_category: 'Estimulación Temprana'
          });
        }
      }} className="block w-full max-w-sm text-white text-lg sm:text-xl font-black rounded-xl px-6 sm:px-8 py-4 mb-4 no-underline text-center shadow-lg hover:opacity-90 transition-opacity" style={{
        background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)'
      }} data-id="element-19">
          🧠 → QUIERO MI MEGAPACK AHORA
        </a>

        {/* ── 8. TRUST BADGES ── */}
        <div className="flex flex-row flex-wrap items-center justify-center gap-3 sm:gap-4 m-0" data-id="element-20">
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-21">
            🛡️ Garantía 7 días
          </span>
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-22">
            🔒 Pago seguro
          </span>
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-23">
            💳 Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </header>

      <main data-id="element-24">
        <SocialProof data-id="element-25" />
        <PainPoints data-id="element-26" />
        <ProductShowcase data-id="element-27" />
        <WhatYouGet data-id="element-28" />
        <Bonuses data-id="element-29" />
        <Countdown data-id="element-30" />
        <Pricing data-id="element-31" />
        <ProBusiness data-id="element-32" />
        <Guarantee data-id="element-33" />
        <Testimonials data-id="element-34" />
        <FAQ data-id="element-35" />
        <DarkCTA data-id="element-36" />
      </main>

      <Footer data-id="element-37" />
      <PurchaseNotifications data-id="element-38" />
    </>;
}